$(document).ready(function() {
  let count = 1
  $(".show_map").addClass("header-bold-text");
  showMapValue = localStorage.getItem('showMap');
  if(showMapValue != null) {
    if ($(".map-toggle").is(":hidden")) {
      showMap = showMapValue == 'true' ? true : false
      mapAndListLayout(showMap)
      $( "#someSwitchOptionDefault" )[0].checked = showMap
    }
  }

  // Show map toggle on desktop view
  $(document).on('click', '#someSwitchOptionDefault', function(){
    localStorage.setItem('showMap', this.checked);
    mapAndListLayout(this.checked);
   });

   $(document).on('click', '#map-btn', function(){
     console.log("button clicked")
    
     if(count % 2 === 1){
      console.log("show")
       document.getElementById('map-container-box').style.height = "unset";
       document.getElementById('map-container-box').style.visibility = "visible";
       $(".map-container").removeClass("d-none");
     }else{
      console.log("hide")
      $(".map-container").addClass("d-none");
     }
     count  = count + 1
   });

  // Map/List toggle on mobile view
  $(document).on('click', '.map-toggle', function(){
    if ($('.course-container').hasClass('mobile-active')){
      $("#tab-btn").html('list');
      $(".list-ico").removeClass('d-none');
      $(".map-ico").addClass('d-none');
      $(".course-container").removeClass("mobile-active");
      $(".map-container").addClass("mobile-active");
      $("#search-form").addClass("d-none");
      $(".course-pagination-box").addClass('d-none');
      $(".courses-suffle-container").addClass("d-none");

    }else {
      $("#tab-btn").html('map');
      $(".map-ico").removeClass('d-none');
      $(".list-ico").addClass('d-none');
      $(".course-container").addClass("mobile-active");
      $(".map-container").removeClass("mobile-active");
      $("#search-form").removeClass("d-none");
      $(".course-pagination-box").removeClass('d-none');

      $(".courses-suffle-container").removeClass("d-none");
      $(".fake-course").css({'padding-right': '0px'});
    }
  });


  if ($('.pagination').length && $('#courses').length) {
    $(window).scroll(function() {
      var url;
      url = $('.pagination .next_page').attr('href');
      if (url && $(window).scrollTop() > $(document).height() - $(window).height() - 100) {
        $('.pagination').text('Loading more courses...');
        $.getScript(url);
      }
    });
    $(window).scroll();
  }

});

function mapAndListLayout(showMapNewValue) {
  console.log(showMapNewValue,67)
  var switchValue = localStorage.getItem('showMap');
  showMap = switchValue == null ? true : showMapNewValue
  if(showMap == true) {
    $(".show_map").addClass("header-bold-text");
    $(".map-container").removeClass("d-none");
    $(".courses-details-box").addClass('d-none');
    $(".course-text-box").removeClass('d-none');

    $(".courses-suffle-container").addClass("col-md-8");
    $(".courses-suffle-container").removeClass("col-md-12");

    $(".course-container").addClass("col-md-12");
    $(".course-container").addClass("col-sm-12");
    $(".course-container").removeClass("col-md-8");
    $(".course-container").removeClass("col-sm-8");

    $(".fake-course").css({ 'padding-right' : 'inherit'});
    $(".fake-course").css({ 'margin-right' : '15px'});
    $("body").addClass("map-on");

    // $(".combined-page-feature-modal").css({ 'top': '-170px', 'right': '-32px' })
    $(".combined-page-feature-modal").addClass('combined-page-feature-modal-with-map')
    $(".combined-page-feature-modal").removeClass('combined-page-feature-modal-without-map')
    equalHeightWhenMapShown();
  } else {
    $(".show_map").removeClass("header-bold-text");
    $(".map-container").addClass("d-none");
    $(".courses-details-box").removeClass('d-none');
    $(".course-text-box").addClass('d-none');

    $(".courses-suffle-container").removeClass("col-md-8");
    $(".courses-suffle-container").addClass("col-md-12");

    $(".course-container").removeClass("col-md-12");
    $(".course-container").removeClass("col-sm-12");
    $(".course-container").addClass("col-md-8");
    $(".course-container").addClass("col-sm-8");

    $(".fake-course").css({ 'padding-right' : '15px'});
    $(".fake-course").css({ 'margin-right' : 'inherit'});
    $("body").removeClass("map-on");

    // $(".combined-page-feature-modal").css({ 'top': '-155px', 'right': '57px' })
    $(".combined-page-feature-modal").addClass('combined-page-feature-modal-without-map')
    $(".combined-page-feature-modal").removeClass('combined-page-feature-modal-with-map')


    equalHeightWhenMapHidden();
  }
}

// Make Courses images and detail section height equal when map is hidden
function equalHeightWhenMapHidden() {
  count = $(".course-container").length;
  for (i = 0; i < count-1; i++) {
    group = $(".course_index_"+i)
    // if($(group[0]).height() > $(group[1]).height() ) {
    //  group.height($(group[0]).height());
    // } else{
    //   group.height($(group[1]).height());
    // }
  }
}

// Make Courses images and detail section height equal when map is shown
function equalHeightWhenMapShown() {
  count = $(".course-container").length;
  for (i = 0; i < count-1; i++) {
    group = $(".course_index_"+i)
    $(group[0]).height('auto');
  }
}

// NOTE: This function is used to reset the bootstrap classes from when the courses
// are loaded with the pagination, function called from views/courses/index.js.erb
function resetCssClass() {
  var windowWidth = $(window).width()
  if(windowWidth >= 801 && windowWidth <= 991) {
    $(".course-container").addClass("col-sm-12");
    $(".courses-details-box").addClass("d-none");
  }
}


$(document).on('click', '.request-submit', function(e){
  if($(this).hasClass('disabled')){
    if (!alert('You have reached the maximum number of rounds you can play at other clubs for this year!')) {
      // olark('api.box.expand');
    }
    e.preventDefault()
  }
})
function save_trip_planner_searched_data(){
  if($('.nearby_form')[0].checkValidity()){
    var searched_from = $('#from').val()
    var searched_to = $('#to').val()
    var searched_range = $('#range').val()
    sessionStorage.setItem("searched_from", searched_from);
    sessionStorage.setItem("searched_to", searched_to);
    sessionStorage.setItem("searched_range", searched_range);
  }
}
$(document).on('submit','form.nearby_form',function(){
  save_trip_planner_searched_data()
});
